import ReviewsCarousel from './ReviewsCarousel';
import { useState } from 'react';

import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const taskItems = [
  'рост позиций компании в поисковой выдаче Яндекс.Карт;',
  'увеличение количества звонков и заявок с карточки;',
  'повышение доверия за счёт отзывов и рейтинга;',
  'корректное отображение адреса, графика работы и контактов;',
  'продвижение организации в конкретном районе или городе;',
  'удаление недостоверной информации и негативных публикаций о компании.',
];

const serviceItems = [
  [
    'Оформление карточки на Яндекс.Картах',
    'Специалисты создают профиль компании в Яндекс.Бизнесе, заполняют название, категорию, адрес и телефон. Добавляют фотографии, описание услуг и режим работы. Полнота карточки напрямую влияет на позиции. Чем больше корректных данных указано, тем выше доверие алгоритмов и пользователей.',
  ],
  [
    'SEO-оптимизация карточки организации',
    'SEO-оптимизация карточки включает подбор ключевых слов, проработку категорий и описания. Специалисты собирают семантическое ядро под тематику бизнеса и вписывают запросы в текстовые поля карточки. Частотные запросы собирают в Яндекс.Вордстате по регионам.',
  ],
  [
    'Продвижение карточки в топ выдачи',
    'Чтобы карточка попала в топ, важна не только оптимизация, но и активность: отзывы, ответы на вопросы, публикации новостей и акций. Всё это усиливает сигнал для алгоритмов Яндекс.Карт. Регулярные публикации показывают, что профиль ведётся живым бизнесом, а не заброшен.',
  ],
  [
    'Улучшение поведенческих факторов карточки',
    'Поведенческие факторы показывают, насколько пользователям интересна карточка: сколько человек кликают по кнопке «Позвонить», строят маршрут или переходят на сайт. Чем выше активность, тем выше позиции. Специалисты анализируют эти показатели в статистике и помогают усилить их специальными доработками.',
  ],
];

const includedItems = [
  [
    'Аудит и анализ карточки компании',
    'На старте специалисты проверяют текущее состояние карточки: заполненность полей, категорию, наличие фото и отзывов. Анализируют карточки конкурентов из того же района и сферы деятельности. По итогам аудита формируется план работ с приоритетными задачами.',
  ],
  [
    'Оформление и заполнение карточки',
    'Заполняют все обязательные поля: юридическое название, адрес, телефон, сайт, часы работы. Добавляют фотографии высокого качества и описание деятельности компании.',
  ],
  [
    'SEO-оптимизация (категории, ключевые слова, описание)',
    'Подбирают основные и дополнительные категории, вписывают ключевые запросы в название и описание. Это усиливает релевантность карточки конкретным поисковым фразам.',
  ],
  [
    'Работа с отзывами',
    'Специалисты помогают собирать новые отзывы и отвечают на существующие, включая негативные. Своевременный ответ на негатив снижает его влияние на рейтинг компании.',
  ],
  [
    'Аналитика и отчётность',
    'Раз в месяц клиент получает отчёт: позиции карточки, количество показов, звонков и переходов на сайт. Отчётность помогает контролировать результат и корректировать стратегию.',
  ],
];

const toolItems = [
  [
    'Яндекс.Бизнес',
    'Яндекс.Бизнес — личный кабинет для управления карточкой компании. Через него редактируют данные, отвечают на отзывы, публикуют новости и следят за статистикой обращений.',
  ],
  [
    'Работа с рейтингом и отзывами',
    'Рейтинг компании складывается из оценок и отзывов пользователей. Регулярная работа с отзывами — сбор новых, ответы на вопросы — постепенно повышает рейтинг карточки.',
  ],
  [
    'Геолокационные факторы ранжирования',
    'Яндекс учитывает расстояние от пользователя до организации, точность GPS-координат и привязку к дому или улице. Чем точнее указано местоположение, тем чаще карточка показывается рядом с целевой аудиторией. При переезде компании важно вовремя обновить адрес и геометку, иначе клиенты продолжат ехать по старому адресу.',
  ],
  [
    'Интеграция с сайтом и другими картами',
    'Карточку связывают с сайтом компании и профилями в 2ГИС и других геосервисах. Это усиливает общий SEO-сигнал и повышает доверие поисковых систем к организации.',
  ],
];

const processItems = [
  [
    'Анализ ниши и конкурентов',
    'Специалисты изучают спрос в нише, смотрят карточки конкурентов в городе или районе. Это помогает понять, какие категории и запросы использовать.',
  ],
  [
    'Оформление карточки',
    'Профиль компании создают или дорабатывают в Яндекс.Бизнесе. Указывают адрес, телефон, сайт и график работы, добавляют фотографии.',
  ],
  [
    'SEO-оптимизация',
    'Вписывают ключевые слова в название, описание и категории. Настраивают карточку под запросы, по которым бизнес ищут в конкретном городе или районе.',
  ],
  [
    'Работа с отзывами',
    'Запускают сбор отзывов от реальных клиентов, отвечают на уже оставленные комментарии. Отдельно прорабатывают негативные отзывы и предлагают решение.',
  ],
  [
    'Мониторинг и корректировка',
    'После запуска специалисты следят за позициями, количеством звонков и переходов. При необходимости корректируют описание, категории и фото карточки.',
  ],
];

const approachItems = [
  [
    'Комплексный подход (SEO + оформление + отзывы)',
    'Только совместная работа над оформлением, SEO-оптимизацией и отзывами даёт устойчивый рост. Один из элементов без остальных даёт слабый и нестабильный результат.',
  ],
  [
    'Прозрачные этапы работ',
    'Клиент заранее видит план работ и сроки каждого этапа. Все изменения в карточке согласовываются и фиксируются в отчётах.',
  ],
  [
    'Фокус на звонках и заявках',
    'Главная цель продвижения — не просто позиции, а звонки, заявки и записи клиентов. Поэтому в отчётах отдельно отслеживается динамика обращений.',
  ],
];

const collaborationItems = [
  [
    'Разовое оформление карточки',
    'Подходит компаниям, которым нужно один раз качественно заполнить и оптимизировать карточку. Без дальнейшего сопровождения.',
  ],
  [
    'Абонентское продвижение',
    'Ежемесячная работа: обновление данных, сбор отзывов, оптимизация под сезонные запросы. Такой формат подходит для системного роста позиций.',
  ],
  [
    'Почасовая работа',
    'Оплата за конкретные задачи: правки карточки, разовые консультации, разбор проблемы с модерацией. Удобно, если нужна точечная помощь.',
  ],
];

const resultItems = [
  [
    'Оформленную карточку компании',
    'Полностью заполненный профиль с актуальными данными, фотографиями и описанием услуг.',
  ],
  [
    'Позиции в топе Яндекс.Карт',
    'Рост позиций по целевым запросам и категориям в своём городе или районе.',
  ],
  [
    'Рост звонков и заявок',
    'Увеличение количества обращений — звонков, переходов на сайт и построений маршрута.',
  ],
  [
    'Положительную репутацию',
    'Больше положительных отзывов и корректная работа с негативом повышают доверие к компании.',
  ],
];

const supportItems = [
  [
    'Техническая поддержка карточки',
    'Специалисты следят за корректностью данных, оперативно исправляют ошибки и проходят повторную модерацию при необходимости.',
  ],
  [
    'SLA и гарантии',
    'Сроки выполнения задач фиксируются заранее. Клиент понимает, в какие сроки будут внесены правки и получен отчёт.',
  ],
  [
    'Доработки и актуализация данных',
    'При смене адреса, телефона или графика работы данные в карточке своевременно обновляются, чтобы клиенты не приезжали по старому адресу.',
  ],
  [
    'SEO-сопровождение',
    'Специалисты регулярно проверяют семантическое ядро, добавляют новые запросы и корректируют категории под изменения спроса.',
  ],
];

const relatedServices = [
  ['SEO под ключ', '/services/seo/full-cycle/'],
  ['Разработка сайтов', '/services/websites/'],
  ['Разработка приложений', '/services/mobile/'],
];

const reviews = [
  '«Карточку оформили за неделю, добавили фото и категории. Через месяц звонков стало заметно больше» — владелец сети кофеен.',
  '«Помогли разобраться с негативными отзывами и настроили регулярный сбор новых. Рейтинг вырос с 4,1 до 4,7» — клиника в Москве.',
  '«Заказывали продвижение для трёх филиалов сразу. Удобно, что все карточки вели по единому стандарту и присылали общий отчёт» — сеть шиномонтажей.',
];

const faqItems = [
  [
    'Сколько стоит продвижение на Яндекс.Картах?',
    'Стоимость зависит от объёма задач: разовое оформление карточки дешевле абонентского продвижения. Точную цену называют после аудита.',
  ],
  [
    'Сроки продвижения?',
    'Оформление карточки занимает от нескольких дней. Первые результаты по позициям заметны через 2–4 недели, устойчивый рост — через 1–3 месяца. Сроки зависят от ниши, конкуренции в городе и стартового состояния профиля.',
  ],
  [
    'Что нужно для старта?',
    'Нужен доступ к аккаунту в Яндекс.Бизнесе или согласие на его создание, актуальные данные о компании, фотографии и описание услуг.',
  ],
  [
    'Как продвигать организацию на Яндекс.Картах?',
    'Нужно заполнить карточку, оптимизировать её под ключевые запросы, собирать отзывы и регулярно обновлять данные. Без комплексного подхода рост позиций будет медленным.',
  ],
];

const structuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Продвижение организации на Яндекс.Картах под ключ',
    url: 'https://fatalitystudio.ru/services/yandex-maps/',
    provider: {
      '@type': 'Organization',
      name: 'Fatality Studio',
      url: 'https://fatalitystudio.ru/',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map(([question, answer]) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  },
];

function ContentHeader({ title, intro, dark = false }) {
  return (
    <div className={`ym-section-head${dark ? ' ym-section-head-dark' : ''}`}>
      <h2>{title}</h2>
      {intro && <p>{intro}</p>}
    </div>
  );
}

function ItemGrid({ items, dark = false }) {
  return (
    <div className={`ym-item-grid${dark ? ' ym-item-grid-dark' : ''}`}>
      {items.map(([title, text], index) => (
        <article className="ym-item" key={`${title}-${index}`}>
          <div className="ym-item-number" aria-hidden="true">
            {String(index + 1).padStart(2, '0')}
          </div>
          <h3>{title}</h3>
          <p>{text}</p>
        </article>
      ))}
    </div>
  );
}

function StandardSection({ title, intro, items, dark = false, children }) {
  return (
    <section className={`${dark ? 'ink' : 'canvas'} sec-pad ym-section`}>
      <div className="container">
        <ContentHeader title={title} intro={intro} dark={dark} />
        {items && <ItemGrid items={items} dark={dark} />}
        {children}
      </div>
    </section>
  );
}

function YandexMapsPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <RedesignPage>
      <PageMeta
        title="Продвижение на Яндекс Картах под ключ - заказать продвижение карточки в Яндекс.Картах"
        description="Закажите продвижение организации на Яндекс.Картах. Оформление карточки, SEO-оптимизация, работа с отзывами и рост позиций в ТОПе. Системный подход, множество кейсов и команда профессионалов. Продвинули более 50 бизнесов в в гео-сервисах. Узнайте стоимость продвижения на Яндекс.Картах и закажите расчёт в  fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
        canonical="https://fatalitystudio.ru/services/yandex-maps/"
        structuredData={structuredData}
        replaceStaticStructuredData
      />
      <RedesignHeader />

      <main>
        <section className="ink service-hero ym-hero">
          <div
            className="glow"
            style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
          />
          <div className="container">
            <h1>Продвижение организации на Яндекс.Картах под ключ</h1>
            <p className="hero-sub">
              Продвижение на Яндекс.Картах помогает бизнесу попасть в ТОП локального поиска. Клиенты находят компанию рядом с собой, звонят и приезжают. Сервис работает как для одной точки, так и для сети филиалов по всей России. Ниже — что входит в услугу, какие инструменты используются и сколько стоит продвижение на Яндекс.Картах.
            </p>
          </div>
        </section>

        <StandardSection title="Продвижение бизнеса на Яндекс.Картах">
          <div className="ym-prose">
            <p>
              Продвижение бизнеса на Яндекс.Картах — это комплекс работ с карточкой организации. Специалисты заполняют профиль компании, добавляют фото, услуги и товары. Затем карточку оптимизируют под ключевые запросы и работают с отзывами.
            </p>
            <p>
              Сервис особенно полезен для локального бизнеса: салонов красоты, автосервисов, клиник, кафе, шиномонтажей. Пользователи чаще ищут услуги «рядом», и от оформления карточки напрямую зависит поток обращений.
            </p>
            <p>
              Без продвижения карточка теряется среди похожих организаций в районе. Пользователь выбирает компанию с более полным профилем и живыми отзывами.
            </p>
          </div>
        </StandardSection>

        <StandardSection
          title="Какие задачи решает продвижение на Яндекс.Картах"
          intro="Комплексное продвижение на Яндекс.Картах закрывает сразу несколько задач бизнеса:"
          dark
        >
          <ul className="source-list ym-task-list">
            {taskItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <p className="ym-section-note">
            Каждая задача требует отдельного подхода: от заполнения профиля до регулярной работы с обращениями клиентов. Игнорирование хотя бы одной из них снижает эффект от остальных.
          </p>
        </StandardSection>

        <StandardSection
          title="Какие услуги продвижения на Яндекс.Картах мы предлагаем"
          intro="В зависимости от целей бизнеса можно выбрать отдельную услугу или комплексное продвижение карточки на Яндекс.Картах. Ниже — четыре основных направления работы."
          items={serviceItems}
        />

        <StandardSection
          title="Что входит в продвижение на Яндекс.Картах"
          intro="Полный цикл продвижения организации на Яндекс.Картах включает пять основных этапов работы."
          items={includedItems}
          dark
        />

        <StandardSection
          title="Инструменты продвижения на Яндекс.Картах"
          intro="Для продвижения используется несколько инструментов, каждый решает свою задачу."
          items={toolItems}
        />

        <StandardSection
          title="Как проходит продвижение организации на Яндекс.Картах"
          intro="Работа строится по понятному алгоритму из пяти шагов."
          items={processItems}
          dark
        />

        <StandardSection
          title="Подход к продвижению на Яндекс.Картах"
          intro="Продвижение строится системно, с прозрачными этапами и понятной целью для бизнеса."
          items={approachItems}
        />

        <StandardSection
          title="Форматы сотрудничества"
          intro="Формат работы подбирается под задачи и бюджет бизнеса."
          items={collaborationItems}
          dark
        />

        <StandardSection
          title="Что вы получаете в итоге"
          intro="После продвижения организации на Яндекс.Картах бизнес получает несколько результатов."
          items={resultItems}
        >
          <aside className="ym-important">
            <strong>ВАЖНО!</strong>
            <p>
              Результат продвижения на Яндекс.Картах виден не мгновенно. Первые изменения по показам заметны через 2–4 недели, стабильный рост занимает 1–3 месяца в зависимости от ниши и конкуренции.
            </p>
          </aside>
        </StandardSection>

        <StandardSection
          title="Поддержка и сопровождение продвижения"
          intro="После запуска карточка нуждается в регулярном обслуживании и контроле."
          items={supportItems}
          dark
        />

        <StandardSection
          title="Стоимость продвижения на Яндекс.Картах"
          intro="Стоимость продвижения на Яндекс.Картах зависит от объёма задач и формата сотрудничества."
        >
          <div className="ym-price-block">
            <h3>От чего зависит цена</h3>
            <p>
              На стоимость влияют: количество карточек, сфера деятельности, состояние профиля на старте и наличие конкуренции в нише. Сеть филиалов обходится дешевле в пересчёте на карточку.
            </p>
          </div>
          <div className="ym-price-block">
            <h3>Примерные цены</h3>
            <div className="ym-table-scroll" role="region" aria-label="Ориентировочные цены" tabIndex="0">
              <table className="ym-price-table">
                <thead>
                  <tr>
                    <th scope="col">Услуга</th>
                    <th scope="col">Что входит</th>
                    <th scope="col">Ориентировочная цена</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Оформление карточки</td>
                    <td>Заполнение профиля, фото, описание</td>
                    <td>от 5 000 ₽</td>
                  </tr>
                  <tr>
                    <td>SEO-оптимизация</td>
                    <td>Подбор запросов, категории, описание</td>
                    <td>от 8 000 ₽</td>
                  </tr>
                  <tr>
                    <td>Абонентское продвижение</td>
                    <td>Комплекс работ ежемесячно</td>
                    <td>от 15 000 ₽/мес</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>
              Точную стоимость продвижения на Яндекс.Картах специалисты называют после аудита карточки и анализа ниши.
            </p>
          </div>
          <div className="ym-price-block">
            <h3>Как рассчитывается стоимость</h3>
            <p>
              Расчёт складывается из объёма работ на старте, количества карточек и выбранного формата — разовое оформление или ежемесячное сопровождение.
            </p>
          </div>
          <div className="ym-price-block">
            <h3>Получить расчёт</h3>
            <p>
              Чтобы узнать точную стоимость, оставьте заявку. Специалист проведёт аудит карточки и предложит расчёт под задачи бизнеса.
            </p>
          </div>
        </StandardSection>

        <StandardSection title="Похожие услуги" dark>
          <div className="ym-related-grid">
            {relatedServices.map(([title, href]) => (
              <SiteLink className="ym-related-link" href={href} key={title}>
                {title}
              </SiteLink>
            ))}
          </div>
        </StandardSection>

        <StandardSection
          title="Кейсы продвижения на Яндекс.Картах"
          intro="Результаты продвижения зависят от ниши, конкуренции и стартового состояния карточки."
        >
          <div className="ym-case-copy">
            <h3>Примеры с результатами</h3>
            <p>
              Например, для сети автосервисов за три месяца число звонков с карточки выросло вдвое. Для салона красоты после оформления фото и сбора отзывов карточка вошла в топ-5 по своему району. Для стоматологической клиники комплексная работа с отзывами подняла рейтинг с 3,9 до 4,6 балла за два месяца.
            </p>
          </div>
        </StandardSection>

        <StandardSection
          title="Отзывы клиентов: от заявки — к росту на Яндекс.Картах"
          intro="Клиенты делятся результатами продвижения на Яндекс.Картах."
          dark
        >
          <ReviewsCarousel className="ym-reviews-grid">
            {reviews.map((review) => (
              <figure className="ym-review" key={review}>
                <blockquote>{review}</blockquote>
              </figure>
            ))}
          </ReviewsCarousel>
        </StandardSection>

        <StandardSection title="Ответы на частые вопросы">
          <div className="faq-list faq-list-wide">
            {faqItems.map(([question, answer], index) => {
              const isOpen = openFaq === index;
              return (
                <article className={`faq-item${isOpen ? ' open' : ''}`} key={question}>
                  <button
                    type="button"
                    className="faq-q"
                    aria-expanded={isOpen}
                    aria-controls={`yandex-maps-faq-${index}`}
                    onClick={() => setOpenFaq(isOpen ? -1 : index)}
                  >
                    <h3 className="faq-question-heading">{question}</h3>
                    <span className="faq-toggle" aria-hidden="true">
                      +
                    </span>
                  </button>
                  <div className="faq-a" id={`yandex-maps-faq-${index}`}>
                    <div className="faq-a-inner">{answer}</div>
                  </div>
                </article>
              );
            })}
          </div>
        </StandardSection>

        <section className="ink lead ym-lead" id="yandex-maps-lead">
          <div className="container lead-grid">
            <div className="lead-side">
              <h2 className="lead-heading">Заказать продвижение на Яндекс.Картах</h2>
              <p className="lead-text">
                Оставьте заявку — специалист проведёт аудит карточки, покажет точки роста и предложит расчёт стоимости продвижения на Яндекс.Картах под ваш бизнес.
              </p>
            </div>
            <LeadForm
              formId="yandex-maps-request"
              idPrefix="yandex-maps"
              submitLabel="Оставить заявку"
            />
          </div>
        </section>
      </main>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default YandexMapsPage;
